import { render, staticRenderFns } from "./ApexDataBarChart.vue?vue&type=template&id=dd3367ea&scoped=true&"
import script from "./ApexDataBarChart.vue?vue&type=script&lang=js&"
export * from "./ApexDataBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexDataBarChart.vue?vue&type=style&index=0&id=dd3367ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3367ea",
  null
  
)

export default component.exports